module.exports = __webpack_public_path__ + "static/media/tierheimhelden.9e2e409b.svg";